import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all
export const retrieveAllAppointment = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            limit: data?.limit || null,
            status: data?.status || null,
            search: data?.search || null,
            startDate: data?.startDate || null,
            endDate: data?.endDate || null,
            currentPage: data?.currentPage || null,
        }
        return asyncThunkWrapper(
            {
                method: "GET",
                url: `${BASEURI}/admin/appointment/retrieve-all`,
                params,
                headers: headers()
            },
            thunkAPI,
            {
                showToast: false,
                returnDataKey: "data"
            }
        )
    }
)


export const deletAppointmentr = createAsyncThunk(
    "delete",
    async (id, thunkAPI) =>
        asyncThunkWrapper(
            {
                method: "DELETE",
                url: `${BASEURI}/admin/appointment/delete/${id}`,
                headers: headers()
            },
            thunkAPI
        )
)
